import * as React from 'react';
import Head from 'next/head';
import { useSelector } from 'react-redux';
import ManageGoals from '@cont/ManageGoals/ManageGoals';
import { useSelectorToStore } from '@hooks/reduxHooks';
import { fetchOnboardingGoals } from '@actions/topologies';
import pushRoute from '@utils/pushRoute';

const Explore = () => {
  const isLoggedIn = useSelector(({ auth }) => auth.isLoggedIn || false);
  const onboardingGoals = useSelectorToStore(
    ({ topologies }) => topologies.onboardingGoals
  );
  const goalLanguages = useSelector(
    ({ topologies }) => topologies.goalLanguages ?? []
  );
  const followedGoals = useSelectorToStore(({ auth }) => auth.followedGoals);
  const segregateGoalGroupsData = React.useCallback((goals) => {
    const goalGroups = [];
    goals.forEach((item) => {
      if (item.uid && item.children && item.children.length > 0) {
        if (item.children[0].children.length === 0) {
          goalGroups.push(item);
          return;
        }
        return item.children.forEach((goalGroup) => {
          goalGroups.push(goalGroup);
        });
      }
    });
    return goalGroups;
  }, []);
  React.useEffect(() => {
    if (isLoggedIn) {
      pushRoute('/manage-goals', '/manage-goals');
    }
  }, [isLoggedIn]);
  const goalGroups = onboardingGoals?.results
    ? segregateGoalGroupsData(onboardingGoals.results)
    : null;
  return (
    <>
      <Head>
        <title>Goals | Unacademy</title>
      </Head>
      {goalGroups ? (
        <ManageGoals
          goalGroupsData={goalGroups}
          goalLanguages={goalLanguages}
          followedGoals={followedGoals}
          isOnboarding
        />
      ) : null}
    </>
  );
};

Explore.pageInfo = {
  name: 'Unacademy Explore',
  layoutOptions: {
    hideSearch: true,
    hideGoalSelector: true
  }
};

export default Explore;

Explore.getInitialProps = async ({ store, isServer, res }) => {
  const { auth } = store.getState();
  const { isLoggedIn } = auth || {};
  if (isServer) {
    if (isLoggedIn) {
      res.writeHead(302, {
        Location: '/manage-goals'
      });
      return res.end();
    }
  }
  await store.dispatch(fetchOnboardingGoals());
  return {};
};
